<template>
  <path
    fill="currentColor"
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M11.0728 3.61863C10.5976 2.79379 9.40241 2.79379 8.9272 3.61863L1.41575 16.6564C0.942891 17.4771 1.5381 18.5 2.48855 18.5H17.5114C18.4619 18.5 19.0571 17.4771 18.5842 16.6564L11.0728 3.61863ZM10 6.18064C10.3452 6.18064 10.625 6.4592 10.625 6.80282V12.4024C10.625 12.746 10.3452 13.0246 10 13.0246C9.65482 13.0246 9.375 12.746 9.375 12.4024V6.80282C9.375 6.4592 9.65482 6.18064 10 6.18064ZM10 14.5178C9.44771 14.5178 9 14.9635 9 15.5133C9 16.0631 9.44771 16.5088 10 16.5088C10.5523 16.5088 11 16.0631 11 15.5133C11 14.9635 10.5523 14.5178 10 14.5178Z" />
</template>
